<template>
  <div class="min-h-screen text-white pt-2 md:pt-8">
    <div class="container max-w-screen-lg mx-auto px-4 py-8 h-full">
      <div class="flex items-center gap-4 mb-6">
        <BackToLoginButton v-if="isStandalone" />
        <h1 class="text-2xl md:text-5xl font-bold md:text-center">
          Training Program
        </h1>
      </div>
      <div class="flex flex-col gap-4 pt-4 md:pt-8">
        <h2 class="text-xl md:text-2xl font-semibold">
          Brain Trainer program consists of training sessions delivered within a
          virtual reality (VR) environment or on your Android or Apple tablet or
          phone.
        </h2>
        <p>
          A "session" is a training period for a day combining eye exercises and
          training games; all games assigned to the training session need to be
          completed to advance to the next day’s training session. Each session
          will be pre-loaded with that day’s assigned training; you will not
          need to worry about choosing the correct games to play to complete the
          session, as our program will advance you seamlessly between games
          within each session. All training sessions start with eye exercises
          and are followed by the assigned training games for the day.
        </p>

        <div class="flex flex-col gap-4">
          <h3>EYE EXERCISES</h3>
          <p>
            You’ll start with three (3) eye exercises each day you train. Each
            exercise has individual instructions provided to you when you access
            each activity.
          </p>
        </div>

        <div class="flex flex-col gap-4">
          <h3>TRAINING GAMES</h3>
          <p>
            The training games consist of a mix of 39 games within the VR
            platform and 15 games within the tablet platform.
          </p>
        </div>

        <ul>
          <li>
            1. Training games in VR and 6 training games on the tablet/phone
            center around multiple-object tracking, and they utilize paddles as
            the primary hand control for VR and tapping for the tablet/phone. At
            the end of each training game, you will play against the Boss, the
            game nemesis, in a fun bonus round.
          </li>
          <li>
            2. Training games in VR and 4 training games on the tablet/phone
            utilize shooters as the primary hand control for VR and tapping for
            the tablet/phone. All of these games center around anticipation and
            working memory. In these games, the Boss appears intermittently to
            serve as a distractor.
          </li>
          <li>
            3. Training games in VR and 4 training games on the tablet/phone
            utilize gloves as the primary hand control to punch targets for VR
            and tapping targets for the tablet/phone. All of these games center
            around working memory, cueing, and attention.
          </li>
          <li>
            4. RhythmIQ is a training game that is based on rhythm and timing.
            Drumsticks serve as hand controls for this game in VR while the
            tablets and phone will use tapping; this training game focuses on
            strengthening visual tracking abilities.
          </li>
        </ul>
        <p>
          For all of the exercises and training games, if you need to pause (or
          are forced to disconnect due to a power outage or losing internet, for
          example), you will have 24 hours to resume play. After 24 hours, your
          session will need to be restarted from the beginning.
        </p>

        <h3>RECOMMENDED TRAINING SCHEDULE</h3>
        <p>
          Brain Trainer strongly recommends training a minimum of three (3) days
          per week. The more repetition you have in training, the better chance
          you have of improving your results. We understand that life may get in
          the way occasionally; don’t let that discourage you. Jump back in as
          soon as you can! {{ appName }} is built with the ability to use daily.
        </p>
        <p>
          Once you have completed your assigned training session for a day, the
          system will open up to allow you to play additional games of your
          choosing (Open Play), up to five (5) games per day. Your training
          sessions will update overnight and be ready to advance you the next
          day.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import BackToLoginButton from "@/components/general/BackToLoginButton.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const store = useStore();
const route = useRoute();
const isStandalone = computed(() => {
  return route.meta.isStandalone;
});

const appName = computed(() => store.getters["location/getAppName"]);
</script>

<style scoped lang="postcss">
h3 {
  @apply text-2xl font-bold;
}
</style>
